import { IAssetPurchaseOrder, IProjectInstallation, ISiteReccee } from '@api/models';
import { Button, Drawer } from '@hyperflake/react-ui-library';
import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'httpConfig/http';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface IProjectInstallationDeleteDrawerProps {
    open: boolean;
    onClose: () => void;
    clientInstallationId: string;
    projectInstallationId: string;
    siteRecce: ISiteReccee | null;
}

const DeleteSiteRecceDrawer = (props: IProjectInstallationDeleteDrawerProps) => {
    const { clientInstallationId, projectInstallationId, open, onClose, siteRecce } = props;
    // const { clientInstaId } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const deleteSiteRecceMutation = useMutation(async (payload: any) => {
        const { data, status } = await http.delete(
            `${
                import.meta.env.VITE_APP_API_URL
            }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${
                siteRecce._id
            }`
        );
        return { data, status };
    });

    const handleDelete = async () => {
        if (siteRecce === null) return onClose();
        try {
            const { data, status } = await deleteSiteRecceMutation.mutateAsync({
                id: siteRecce._id,
            });
            console.log({ data, status });
            toast.success('Recce Deleted Successfully.');
            // queryClient.setQueryData<IClientInstallation[]>(['client-installations'], (prev) => {
            //     if (!prev) return;

            //     const index = prev.findIndex((c) => c._id === clientInstallation._id);
            //     return produce(prev, (draft) => {
            //         draft.splice(index, 1);
            //         return draft;
            //     });
            // });
            onClose();
            navigate(
                `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/recce`
            );
        } catch (ex: any) {
            onClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={onClose} title="Confirm Delete">
            <div>
                <div>
                    <Label className="mt-8 inline-block">
                        The following Recce &ldquo;
                        <span className="font-bold">{siteRecce?._id}</span>&rdquo; will be deleted.
                    </Label>

                    <div className="flex gap-2 mt-2">
                        <Button
                            disabled={deleteSiteRecceMutation.isLoading}
                            onClick={() => onClose()}
                            variant="default"
                            color={'primary'}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={deleteSiteRecceMutation.isLoading}
                            className="w-20"
                            onClick={() => handleDelete()}
                            variant="default"
                            color={'danger'}
                        >
                            {deleteSiteRecceMutation.isLoading ? <CircularProgress size={18} /> : 'Delete'}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default DeleteSiteRecceDrawer;
